<template>
  <div>
    <div class="card-body">
      <fieldset>
        <legend class="d-flex justify-content-between mb-0">
          <span>
            Documents
          </span>
          <div class="card-header-buttons">
            <button
              type="button"
              class="btn btn-primary"
              v-if="!readonly"
              @click="openAddDocumentModal"
            >
              Add Document
            </button>
          </div>
        </legend>
      </fieldset>
    </div>

    <table class="table carpenter">
      <thead>
        <tr>
          <th>Name</th>
          <th>Description</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-bind:key="index" v-for="(document, index) in documents">
          <td>{{ document.file_name }}</td>
          <td>{{ document.description }}</td>
          <td>
            <button
              type="button"
              class="btn btn-primary"
              @click="viewDocument(document)"
            >
              View
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="deleteDocument(document)"
              v-if="hasPermission('documents.delete') && !readonly"
            >
              Delete Document
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="card-footer text-right" v-if="showPagination">
      <pagination
        :data="paginator_data"
        v-on:updateResults="getData"
      ></pagination>
    </div>

    <add-vehicle-document
      :vehicle="vehicle"
      :user="user"
      :show="modals.add"
      @close="closeAddDocumentModal"
      @added="documentAdded"
    ></add-vehicle-document>
  </div>
</template>

<script>
import AddVehicleDocument from '@/components/Modules/Fleet/Tabs/Documents/AddVehicleDocument';

export default {
  props: {
    vehicle: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  components: {
    AddVehicleDocument
  },

  data() {
    return {
      documents: [],
      paginator_data: null,
      filters: {},
      modals: {
        add: false
      }
    };
  },

  computed: {
    showPagination() {
      return (
        this.paginator_data?.next_page_url || this.paginator_data?.prev_page_url
      );
    }
  },

  mounted() {
    this.loadDocuments();
  },

  methods: {
    loadDocuments() {
      this.getData(
        `/fleet/${this.user?.tenant?.identifier}/${this.vehicle.identifier}/documents?per_page=${this.perPage}`
      );
    },

    openAddDocumentModal() {
      this.modals.add = true;
    },

    closeAddDocumentModal() {
      this.modals.add = false;
    },

    documentAdded() {
      this.modals.add = false;

      this.loadDocuments();

      window.toastify.success(
        'Success!',
        'The document was uploaded successfully!'
      );
    },

    viewDocument(document) {
      window.open(document.url, '_blank');
    },

    deleteDocument(document) {
      window
        .swal({
          title: 'Are you sure?',
          text: 'This will permanently remove the document',
          type: 'warning',
          showCancelButton: true
        })
        .then(() => {
          window.Ajax.delete(
            `/fleet/${this.user?.tenant?.identifier}/${this.vehicle.identifier}/documents/${document.identifier}`
          )
            .then(response => {
              window.toastify.success('Deleted', 'The document was deleted!');

              let found = this.documents.findIndex(record => {
                return record.identifier === document.identifier;
              });

              if (found > -1) {
                this.documents.splice(found, 1);
              }
            })
            .catch(error => {});
        });
    },

    getData(url) {
      window.Ajax.get(url)
        .then(response => {
          this.documents = response.data.data;
          this.paginator_data = response.data;
        })
        .catch(() => {
          window.toastify.error(
            'Error',
            'Sorry, an error occurred while loading the documents'
          );
        });
    }
  }
};
</script>
